module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEFSURBVCiRY2ZAAgERGQoymkb/7107+5MBB2BC5vxlYKjnYmbeGhpayEmUhu9//xUwMDLw/mL5sTI0NJSZoIY9q2d9/Mn81+MfA4PeTxaRuQwMDIx4NTAwMDDsXDLrOSMzgzsDA4O3b0RmF7o8VmtvXjrzVlPP5CADA+MUDR3TjzevnDmN0wYU8J+B8R8jqhoMNzIwMDD4xWSqM/xlOMLA8H/hpuUzSvBqcI9Jk2T7y3yc4f//Q5tXzIhnYGD4jyyPYp1LaBo/+1/mHUwMDJc+v5BIQlfMwMDAwILM4WRh7mf4z/CZ7S9H+IEDDX+wORdFw19GpkbuP69erV69+js2xQwMDAwAjMZPCUWfi1oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/right.png
// module id = p8mP
// module chunks = 1